// src/pages/Unauthorized.jsx
const Unauthorized = () => (
  <div className="text-center mt-5">
    <h2>Acceso denegado</h2>
    <p>No tienes permisos para ver esta sección.</p>
  </div>
);

export default Unauthorized;
